export { default } from './SpeakMonkey';

import './SpeakMonkey.scss';
